function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 436c28.499 0 54.313-11.501 73.251-30h-58.251c-33.091 0-60-26.909-60-60 0-19.878 9.58-37.661 24.712-48.618-23.458-14.63-54.932-14.297-78.77.258-3.565 10.541-5.942 21.632-5.942 33.36 0 57.891 47.109 105 105 105z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.882 291.698 17.842 20.288-26.66 4.409c-14.517 2.403-25.064 14.854-25.064 29.605 0 16.538 13.462 30 30 30h79.468c6.555-13.693 10.532-28.835 10.532-45 0-57.891-47.109-105-105-105-29.59 0-56.246 12.413-75.353 32.177 34.325-4.587 70.823 6.885 94.235 33.521z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 120h450v-120h-450zm270-75h120v30h-120zm-150 0h30v30h-30zm-60 0h30v30h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 512h450v-362h-450zm225-316c74.443 0 135 60.557 135 135s-60.557 135-135 135-135-60.557-135-135 60.557-135 135-135z"
}));

function Svg79(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg79);
export default __webpack_public_path__ + "static/media/7_9.226b8900.svg";
export { ForwardRef as ReactComponent };